import * as types from './constants';


export const initialState = {
  dataTable: [],
  allSelected: false,
  loading: false,
  count: 0,
  next: null,
  previous: null,
  curr_page: 1,
  errors_api: {},
  queryParsed: false,
  message: null
};

const actions = {
  // Get Discover Brands
  [types.GET_DISCOVER_BRANDS_REQUEST]: state => {
    const data = {
      ...state,
      dataTable: [],
      loading: true
    };

    return { ...data };
  },

  [types.GET_DISCOVER_BRANDS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      ...payload
    };

    return { ...data };
  },

  [types.GET_DISCOVER_BRANDS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_DISCOVER_BRANDS_RESET]: () => {
    return { ...initialState };
  },

  // Operations
  [types.DISCOVER_BRANDS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      curr_page: parseInt(payload) || 1,
      queryParsed: true
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};